const all_anchor_combinations =
{
	a1: { index: 'a1', anchor_x: 'left', anchor_y: 'top', direction_x: 'left', direction_y: 'top' },
	a2: { index: 'a2', anchor_x: 'center', anchor_y: 'top', direction_x: 'left', direction_y: 'top' },
	a3: { index: 'a3', anchor_x: 'right', anchor_y: 'top', direction_x: 'left', direction_y: 'top' },
	a4: { index: 'a4', anchor_x: 'left', anchor_y: 'center', direction_x: 'left', direction_y: 'top' },
	a5: { index: 'a5', anchor_x: 'center', anchor_y: 'center', direction_x: 'left', direction_y: 'top' },
	a6: { index: 'a6', anchor_x: 'right', anchor_y: 'center', direction_x: 'left', direction_y: 'top' },
	a7: { index: 'a7', anchor_x: 'left', anchor_y: 'bottom', direction_x: 'left', direction_y: 'top' },
	a8: { index: 'a8', anchor_x: 'center', anchor_y: 'bottom', direction_x: 'left', direction_y: 'top' },
	a9: { index: 'a9', anchor_x: 'right', anchor_y: 'bottom', direction_x: 'left', direction_y: 'top' },
	
	b1: { index: 'b1', anchor_x: 'left', anchor_y: 'top', direction_x: 'center', direction_y: 'top' },
	b2: { index: 'b2', anchor_x: 'center', anchor_y: 'top', direction_x: 'center', direction_y: 'top' },
	b3: { index: 'b3', anchor_x: 'right', anchor_y: 'top', direction_x: 'center', direction_y: 'top' },
	b4: { index: 'b4', anchor_x: 'left', anchor_y: 'center', direction_x: 'center', direction_y: 'top' },
	b5: { index: 'b5', anchor_x: 'center', anchor_y: 'center', direction_x: 'center', direction_y: 'top' },
	b6: { index: 'b6', anchor_x: 'right', anchor_y: 'center', direction_x: 'center', direction_y: 'top' },
	b7: { index: 'b7', anchor_x: 'left', anchor_y: 'bottom', direction_x: 'center', direction_y: 'top' },
	b8: { index: 'b8', anchor_x: 'center', anchor_y: 'bottom', direction_x: 'center', direction_y: 'top' },
	b9: { index: 'b9', anchor_x: 'right', anchor_y: 'bottom', direction_x: 'center', direction_y: 'top' },
	
	c1: { index: 'c1', anchor_x: 'left', anchor_y: 'top', direction_x: 'right', direction_y: 'top' },
	c2: { index: 'c2', anchor_x: 'center', anchor_y: 'top', direction_x: 'right', direction_y: 'top' },
	c3: { index: 'c3', anchor_x: 'right', anchor_y: 'top', direction_x: 'right', direction_y: 'top' },
	c4: { index: 'c4', anchor_x: 'left', anchor_y: 'center', direction_x: 'right', direction_y: 'top' },
	c5: { index: 'c5', anchor_x: 'center', anchor_y: 'center', direction_x: 'right', direction_y: 'top' },
	c6: { index: 'c6', anchor_x: 'right', anchor_y: 'center', direction_x: 'right', direction_y: 'top' },
	c7: { index: 'c7', anchor_x: 'left', anchor_y: 'bottom', direction_x: 'right', direction_y: 'top' },
	c8: { index: 'c8', anchor_x: 'center', anchor_y: 'bottom', direction_x: 'right', direction_y: 'top' },
	c9: { index: 'c9', anchor_x: 'right', anchor_y: 'bottom', direction_x: 'right', direction_y: 'top' },
	
	d1: { index: 'd1', anchor_x: 'left', anchor_y: 'top', direction_x: 'left', direction_y: 'center' },
	d2: { index: 'd2', anchor_x: 'center', anchor_y: 'top', direction_x: 'left', direction_y: 'center' },
	d3: { index: 'd3', anchor_x: 'right', anchor_y: 'top', direction_x: 'left', direction_y: 'center' },
	d4: { index: 'd4', anchor_x: 'left', anchor_y: 'center', direction_x: 'left', direction_y: 'center' },
	d5: { index: 'd5', anchor_x: 'center', anchor_y: 'center', direction_x: 'left', direction_y: 'center' },
	d6: { index: 'd6', anchor_x: 'right', anchor_y: 'center', direction_x: 'left', direction_y: 'center' },
	d7: { index: 'd7', anchor_x: 'left', anchor_y: 'bottom', direction_x: 'left', direction_y: 'center' },
	d8: { index: 'd8', anchor_x: 'center', anchor_y: 'bottom', direction_x: 'left', direction_y: 'center' },
	d9: { index: 'd9', anchor_x: 'right', anchor_y: 'bottom', direction_x: 'left', direction_y: 'center' },
	
	f1: { index: 'f1', anchor_x: 'left', anchor_y: 'top', direction_x: 'right', direction_y: 'center' },
	f2: { index: 'f2', anchor_x: 'center', anchor_y: 'top', direction_x: 'right', direction_y: 'center' },
	f3: { index: 'f3', anchor_x: 'right', anchor_y: 'top', direction_x: 'right', direction_y: 'center' },
	f4: { index: 'f4', anchor_x: 'left', anchor_y: 'center', direction_x: 'right', direction_y: 'center' },
	f5: { index: 'f5', anchor_x: 'center', anchor_y: 'center', direction_x: 'right', direction_y: 'center' },
	f6: { index: 'f6', anchor_x: 'right', anchor_y: 'center', direction_x: 'right', direction_y: 'center' },
	f7: { index: 'f7', anchor_x: 'left', anchor_y: 'bottom', direction_x: 'right', direction_y: 'center' },
	f8: { index: 'f8', anchor_x: 'center', anchor_y: 'bottom', direction_x: 'right', direction_y: 'center' },
	f9: { index: 'f9', anchor_x: 'right', anchor_y: 'bottom', direction_x: 'right', direction_y: 'center' },
	
	g1: { index: 'g1', anchor_x: 'left', anchor_y: 'top', direction_x: 'left', direction_y: 'bottom' },
	g2: { index: 'g2', anchor_x: 'center', anchor_y: 'top', direction_x: 'left', direction_y: 'bottom' },
	g3: { index: 'g3', anchor_x: 'right', anchor_y: 'top', direction_x: 'left', direction_y: 'bottom' },
	g4: { index: 'g4', anchor_x: 'left', anchor_y: 'center', direction_x: 'left', direction_y: 'bottom' },
	g5: { index: 'g5', anchor_x: 'center', anchor_y: 'center', direction_x: 'left', direction_y: 'bottom' },
	g6: { index: 'g6', anchor_x: 'right', anchor_y: 'center', direction_x: 'left', direction_y: 'bottom' },
	g7: { index: 'g7', anchor_x: 'left', anchor_y: 'bottom', direction_x: 'left', direction_y: 'bottom' },
	g8: { index: 'g8', anchor_x: 'center', anchor_y: 'bottom', direction_x: 'left', direction_y: 'bottom' },
	g9: { index: 'g9', anchor_x: 'right', anchor_y: 'bottom', direction_x: 'left', direction_y: 'bottom' },
	
	h1: { index: 'h1', anchor_x: 'left', anchor_y: 'top', direction_x: 'center', direction_y: 'bottom' },
	h2: { index: 'h2', anchor_x: 'center', anchor_y: 'top', direction_x: 'center', direction_y: 'bottom' },
	h3: { index: 'h3', anchor_x: 'right', anchor_y: 'top', direction_x: 'center', direction_y: 'bottom' },
	h4: { index: 'h4', anchor_x: 'left', anchor_y: 'center', direction_x: 'center', direction_y: 'bottom' },
	h5: { index: 'h5', anchor_x: 'center', anchor_y: 'center', direction_x: 'center', direction_y: 'bottom' },
	h6: { index: 'h6', anchor_x: 'right', anchor_y: 'center', direction_x: 'center', direction_y: 'bottom' },
	h7: { index: 'h7', anchor_x: 'left', anchor_y: 'bottom', direction_x: 'center', direction_y: 'bottom' },
	h8: { index: 'h8', anchor_x: 'center', anchor_y: 'bottom', direction_x: 'center', direction_y: 'bottom' },
	h9: { index: 'h9', anchor_x: 'right', anchor_y: 'bottom', direction_x: 'center', direction_y: 'bottom' },
	
	i1: { index: 'i1', anchor_x: 'left', anchor_y: 'top', direction_x: 'right', direction_y: 'bottom' },
	i2: { index: 'i2', anchor_x: 'center', anchor_y: 'top', direction_x: 'right', direction_y: 'bottom' },
	i3: { index: 'i3', anchor_x: 'right', anchor_y: 'top', direction_x: 'right', direction_y: 'bottom' },
	i4: { index: 'i4', anchor_x: 'left', anchor_y: 'center', direction_x: 'right', direction_y: 'bottom' },
	i5: { index: 'i5', anchor_x: 'center', anchor_y: 'center', direction_x: 'right', direction_y: 'bottom' },
	i6: { index: 'i6', anchor_x: 'right', anchor_y: 'center', direction_x: 'right', direction_y: 'bottom' },
	i7: { index: 'i7', anchor_x: 'left', anchor_y: 'bottom', direction_x: 'right', direction_y: 'bottom' },
	i8: { index: 'i8', anchor_x: 'center', anchor_y: 'bottom', direction_x: 'right', direction_y: 'bottom' },
	i9: { index: 'i9', anchor_x: 'right', anchor_y: 'bottom', direction_x: 'right', direction_y: 'bottom' }
};


const usable_anchor_combinations =
{
	a1: { index: 'a1', anchor_x: 'left', anchor_y: 'top', direction_x: 'left', direction_y: 'top' },
	a2: { index: 'a2', anchor_x: 'center', anchor_y: 'top', direction_x: 'left', direction_y: 'top' },
	a3: { index: 'a3', anchor_x: 'right', anchor_y: 'top', direction_x: 'left', direction_y: 'top' },
	a4: { index: 'a4', anchor_x: 'left', anchor_y: 'center', direction_x: 'left', direction_y: 'top' },
	a7: { index: 'a7', anchor_x: 'left', anchor_y: 'bottom', direction_x: 'left', direction_y: 'top' },
	
	b1: { index: 'b1', anchor_x: 'left', anchor_y: 'top', direction_x: 'center', direction_y: 'top' },
	b2: { index: 'b2', anchor_x: 'center', anchor_y: 'top', direction_x: 'center', direction_y: 'top' },
	b3: { index: 'b3', anchor_x: 'right', anchor_y: 'top', direction_x: 'center', direction_y: 'top' },
	
	c1: { index: 'c1', anchor_x: 'left', anchor_y: 'top', direction_x: 'right', direction_y: 'top' },
	c2: { index: 'c2', anchor_x: 'center', anchor_y: 'top', direction_x: 'right', direction_y: 'top' },
	c3: { index: 'c3', anchor_x: 'right', anchor_y: 'top', direction_x: 'right', direction_y: 'top' },
	c6: { index: 'c6', anchor_x: 'right', anchor_y: 'center', direction_x: 'right', direction_y: 'top' },
	c9: { index: 'c9', anchor_x: 'right', anchor_y: 'bottom', direction_x: 'right', direction_y: 'top' },
	
	d1: { index: 'd1', anchor_x: 'left', anchor_y: 'top', direction_x: 'left', direction_y: 'center' },
	d4: { index: 'd4', anchor_x: 'left', anchor_y: 'center', direction_x: 'left', direction_y: 'center' },
	d7: { index: 'd7', anchor_x: 'left', anchor_y: 'bottom', direction_x: 'left', direction_y: 'center' },
	
	f3: { index: 'f3', anchor_x: 'right', anchor_y: 'top', direction_x: 'right', direction_y: 'center' },
	f6: { index: 'f6', anchor_x: 'right', anchor_y: 'center', direction_x: 'right', direction_y: 'center' },
	f9: { index: 'f9', anchor_x: 'right', anchor_y: 'bottom', direction_x: 'right', direction_y: 'center' },
	
	g1: { index: 'g1', anchor_x: 'left', anchor_y: 'top', direction_x: 'left', direction_y: 'bottom' },
	g4: { index: 'g4', anchor_x: 'left', anchor_y: 'center', direction_x: 'left', direction_y: 'bottom' },
	g7: { index: 'g7', anchor_x: 'left', anchor_y: 'bottom', direction_x: 'left', direction_y: 'bottom' },
	g8: { index: 'g8', anchor_x: 'center', anchor_y: 'bottom', direction_x: 'left', direction_y: 'bottom' },
	g9: { index: 'g9', anchor_x: 'right', anchor_y: 'bottom', direction_x: 'left', direction_y: 'bottom' },
	
	h7: { index: 'h7', anchor_x: 'left', anchor_y: 'bottom', direction_x: 'center', direction_y: 'bottom' },
	h8: { index: 'h8', anchor_x: 'center', anchor_y: 'bottom', direction_x: 'center', direction_y: 'bottom' },
	h9: { index: 'h9', anchor_x: 'right', anchor_y: 'bottom', direction_x: 'center', direction_y: 'bottom' },
	
	i3: { index: 'i3', anchor_x: 'right', anchor_y: 'top', direction_x: 'right', direction_y: 'bottom' },
	i6: { index: 'i6', anchor_x: 'right', anchor_y: 'center', direction_x: 'right', direction_y: 'bottom' },
	i7: { index: 'i7', anchor_x: 'left', anchor_y: 'bottom', direction_x: 'right', direction_y: 'bottom' },
	i8: { index: 'i8', anchor_x: 'center', anchor_y: 'bottom', direction_x: 'right', direction_y: 'bottom' },
	i9: { index: 'i9', anchor_x: 'right', anchor_y: 'bottom', direction_x: 'right', direction_y: 'bottom' }
};


//


function Get_anchor_combination ( index, flip_priority )
{
	switch ( index )
	{
		case 'a5': return flip_priority == 'horizontal' ? usable_anchor_combinations.a4 : usable_anchor_combinations.a2;
		case 'a6': return flip_priority == 'horizontal' ? usable_anchor_combinations.a4 : usable_anchor_combinations.a3;
		case 'a8': return flip_priority == 'horizontal' ? usable_anchor_combinations.a7 : usable_anchor_combinations.a2;
		case 'a9': return flip_priority == 'horizontal' ? usable_anchor_combinations.a7 : usable_anchor_combinations.a3;
		
		case 'b4':
		case 'b7': return usable_anchor_combinations.b1;
		case 'b5':
		case 'b8': return usable_anchor_combinations.b2;
		case 'b6':
		case 'b9': return usable_anchor_combinations.b3;
		
		case 'c4': return flip_priority == 'horizontal' ? usable_anchor_combinations.c6 : usable_anchor_combinations.c1;
		case 'c5': return flip_priority == 'horizontal' ? usable_anchor_combinations.c6 : usable_anchor_combinations.c2;
		case 'c7': return flip_priority == 'horizontal' ? usable_anchor_combinations.c9 : usable_anchor_combinations.c1;
		case 'c8': return flip_priority == 'horizontal' ? usable_anchor_combinations.c9 : usable_anchor_combinations.c2;
		
		case 'd2':
		case 'd3': return usable_anchor_combinations.d1;
		case 'd5':
		case 'd6': return usable_anchor_combinations.d4;
		case 'd8':
		case 'd9': return usable_anchor_combinations.d7;
		
		case 'e1': return flip_priority == 'horizontal' ? usable_anchor_combinations.d1 : usable_anchor_combinations.b1;
		case 'e2': return flip_priority == 'horizontal' ? usable_anchor_combinations.f3 : usable_anchor_combinations.b2;
		case 'e3': return flip_priority == 'horizontal' ? usable_anchor_combinations.f3 : usable_anchor_combinations.b3;
		case 'e4': return flip_priority == 'horizontal' ? usable_anchor_combinations.d4 : usable_anchor_combinations.h7;
		case 'e5': return flip_priority == 'horizontal' ? usable_anchor_combinations.f6 : usable_anchor_combinations.h8;
		case 'e6': return flip_priority == 'horizontal' ? usable_anchor_combinations.f6 : usable_anchor_combinations.h9;
		case 'e7': return flip_priority == 'horizontal' ? usable_anchor_combinations.d7 : usable_anchor_combinations.h7;
		case 'e8': return flip_priority == 'horizontal' ? usable_anchor_combinations.f9 : usable_anchor_combinations.h8;
		case 'e9': return flip_priority == 'horizontal' ? usable_anchor_combinations.f9 : usable_anchor_combinations.h9;
		
		case 'f1': return flip_priority == 'horizontal' ? usable_anchor_combinations.f3 : usable_anchor_combinations.c1;
		case 'f2': return flip_priority == 'horizontal' ? usable_anchor_combinations.f3 : usable_anchor_combinations.c2;
		case 'f4': return flip_priority == 'horizontal' ? usable_anchor_combinations.f6 : usable_anchor_combinations.i7;
		case 'f5': return flip_priority == 'horizontal' ? usable_anchor_combinations.f6 : usable_anchor_combinations.i8;
		case 'f7': return flip_priority == 'horizontal' ? usable_anchor_combinations.f9 : usable_anchor_combinations.i7;
		case 'f8': return flip_priority == 'horizontal' ? usable_anchor_combinations.f9 : usable_anchor_combinations.i8;
		
		case 'g2': return flip_priority == 'horizontal' ? usable_anchor_combinations.g1 : usable_anchor_combinations.g8;
		case 'g3': return flip_priority == 'horizontal' ? usable_anchor_combinations.g1 : usable_anchor_combinations.g9;
		case 'g5': return flip_priority == 'horizontal' ? usable_anchor_combinations.g4 : usable_anchor_combinations.g8;
		case 'g6': return flip_priority == 'horizontal' ? usable_anchor_combinations.g4 : usable_anchor_combinations.g9;
		
		case 'h1': return flip_priority == 'horizontal' ? usable_anchor_combinations.g1 : usable_anchor_combinations.h7;
		case 'h2': return flip_priority == 'horizontal' ? usable_anchor_combinations.i3 : usable_anchor_combinations.h8;
		case 'h3': return flip_priority == 'horizontal' ? usable_anchor_combinations.i3 : usable_anchor_combinations.h9;
		case 'h4': return flip_priority == 'horizontal' ? usable_anchor_combinations.g4 : usable_anchor_combinations.h7;
		case 'h5': return flip_priority == 'horizontal' ? usable_anchor_combinations.i6 : usable_anchor_combinations.h8;
		case 'h6': return flip_priority == 'horizontal' ? usable_anchor_combinations.i6 : usable_anchor_combinations.h9;
		
		case 'i1': return flip_priority == 'horizontal' ? usable_anchor_combinations.i3 : usable_anchor_combinations.i7;
		case 'i2': return flip_priority == 'horizontal' ? usable_anchor_combinations.i3 : usable_anchor_combinations.i8;
		case 'i4': return flip_priority == 'horizontal' ? usable_anchor_combinations.i6 : usable_anchor_combinations.i7;
		case 'i5': return flip_priority == 'horizontal' ? usable_anchor_combinations.i6 : usable_anchor_combinations.i8;
	}
	
	return usable_anchor_combinations[index];
}


function Get_combination_index ( anchor_x, anchor_y, direction_x, direction_y )
{
	const combinations =
	{
		'left top': { letter: 'a', index: 1 },
		'center top': { letter: 'b', index: 2 },
		'right top': { letter: 'c', index: 3 },
		'left center': { letter: 'd', index: 4 },
		'center center': { letter: 'e', index: 5 },
		'right center': { letter: 'f', index: 6 },
		'left bottom': { letter: 'g', index: 7 },
		'center bottom': { letter: 'h', index: 8 },
		'right bottom': { letter: 'i', index: 9 }
	};
	
	let anchor = `${anchor_x} ${anchor_y}`;
	let direction = `${direction_x} ${direction_y}`;
	
	let letter = '';
	let index = '';
	
	for ( const combination in combinations )
	{
		if ( combination == anchor )
			index = combinations[combination].index;
		
		if ( combination == direction )
			letter = combinations[combination].letter;
	}
	
	return `${letter}${index}`;
}


function Get_anchor_combination_for_collision ( mode, index )
{
	const substitutions_x =
	{
		a1: usable_anchor_combinations.c3,
		a2: usable_anchor_combinations.c2,
		a3: usable_anchor_combinations.c1,
		a4: usable_anchor_combinations.c6,
		a7: usable_anchor_combinations.c9,
		
		c1: usable_anchor_combinations.a3,
		c2: usable_anchor_combinations.a2,
		c3: usable_anchor_combinations.a1,
		c6: usable_anchor_combinations.a4,
		c9: usable_anchor_combinations.a7,
		
		d1: usable_anchor_combinations.f3,
		d4: usable_anchor_combinations.f6,
		d7: usable_anchor_combinations.f9,
		
		f3: usable_anchor_combinations.d1,
		f6: usable_anchor_combinations.d4,
		f9: usable_anchor_combinations.d7,
		
		g1: usable_anchor_combinations.i3,
		g4: usable_anchor_combinations.i6,
		g7: usable_anchor_combinations.i9,
		g8: usable_anchor_combinations.i8,
		g9: usable_anchor_combinations.i7,
		
		i3: usable_anchor_combinations.g1,
		i6: usable_anchor_combinations.g4,
		i7: usable_anchor_combinations.g9,
		i8: usable_anchor_combinations.g8,
		i9: usable_anchor_combinations.g7
	};
	
	const substitutions_y =
	{
		a1: usable_anchor_combinations.g7,
		a2: usable_anchor_combinations.g8,
		a3: usable_anchor_combinations.g9,
		a4: usable_anchor_combinations.g4,
		a7: usable_anchor_combinations.g1,
		
		b1: usable_anchor_combinations.h7,
		b2: usable_anchor_combinations.h8,
		b3: usable_anchor_combinations.h9,
		
		c1: usable_anchor_combinations.i7,
		c2: usable_anchor_combinations.i8,
		c4: usable_anchor_combinations.i9,
		c6: usable_anchor_combinations.i6,
		c9: usable_anchor_combinations.i3,
		
		g1: usable_anchor_combinations.a7,
		g4: usable_anchor_combinations.a4,
		g7: usable_anchor_combinations.a1,
		g8: usable_anchor_combinations.a2,
		g9: usable_anchor_combinations.a3,
		
		h7: usable_anchor_combinations.b1,
		h8: usable_anchor_combinations.b2,
		h9: usable_anchor_combinations.b3,
		
		i3: usable_anchor_combinations.c9,
		i6: usable_anchor_combinations.c6,
		i7: usable_anchor_combinations.c1,
		i8: usable_anchor_combinations.c2,
		i9: usable_anchor_combinations.c3
	};
	
	const substitutions_xy =
	{
		a1: usable_anchor_combinations.i9,
		a2: usable_anchor_combinations.i8,
		a3: usable_anchor_combinations.i7,
		a4: usable_anchor_combinations.i6,
		a7: usable_anchor_combinations.i3,
		
		c1: usable_anchor_combinations.g9,
		c2: usable_anchor_combinations.g8,
		c3: usable_anchor_combinations.g7,
		c6: usable_anchor_combinations.g4,
		c9: usable_anchor_combinations.g1,
		
		d1: usable_anchor_combinations.f3,
		d4: usable_anchor_combinations.f6,
		d7: usable_anchor_combinations.f9,
		
		f3: usable_anchor_combinations.d1,
		f6: usable_anchor_combinations.d4,
		f9: usable_anchor_combinations.d7,
		
		g1: usable_anchor_combinations.c9,
		g4: usable_anchor_combinations.c6,
		g7: usable_anchor_combinations.c3,
		g8: usable_anchor_combinations.c2,
		g9: usable_anchor_combinations.c1,
		
		i3: usable_anchor_combinations.a7,
		i6: usable_anchor_combinations.a4,
		i7: usable_anchor_combinations.a3,
		i8: usable_anchor_combinations.a2,
		i9: usable_anchor_combinations.a1
	};
	
	switch ( mode )
	{
		case 'xy': origin = substitutions_xy; break;
		case 'x': origin = substitutions_x; break;
		case 'y':
		default: origin = substitutions_y;
	}
	
	return ( index in origin ) ? origin[index] : false;
}


export function Get_anchored_position ( element, anchor, direction = {}, allow_collision = false )
{
	if ( !element || !( 'element' in anchor ) || ! anchor.element )
		return { x: '0px', y: '0px' };
	
	
	//-----------------------------------------------
	// Fix the configurations with default values
	//-----------------------------------------------
	
	let a = {};
	
	a.element = anchor.element;
	a.x = ( 'x' in anchor ) && [ 'left', 'center', 'right' ].includes( anchor.x ) ? anchor.x : 'left';
	a.y = ( 'y' in anchor ) && [ 'top', 'center', 'bottom' ].includes( anchor.y ) ? anchor.y : 'bottom';
	a.delta_x = 'delta_x' in anchor ? anchor.delta_x : '0px';
	a.delta_y = 'delta_y' in anchor ? anchor.delta_y : '0px';
	a.flip_priority = ( 'flip_priority' in anchor ) && [ 'horizontal', 'vertical' ].includes( anchor.flip_priority )
		? anchor.flip_priority
		: 'vertical';
	
	let d = {};
	
	d.x = ( 'x' in direction ) && [ 'left', 'center', 'right' ].includes( direction.x ) ? direction.x : 'right';
	d.y = ( 'y' in direction ) && [ 'top', 'center', 'bottom' ].includes( direction.y ) ? direction.y : 'bottom';
	
	//
	
	let anchor_bounds = a.element.getBoundingClientRect();
	let element_bounds = element.getBoundingClientRect();
	
	
	//-----------------------------------------------
	// Get the proper (fixed) combination
	//-----------------------------------------------
	
	const c = allow_collision
		? all_anchor_combinations[Get_combination_index( a.x, a.y, d.x, d.y )]
		: Get_anchor_combination( Get_combination_index( a.x, a.y, d.x, d.y ), a.flip_priority );
	
	
	//--------------------------------
	// X coordinate
	//--------------------------------
	
	let x = 0;
	
	let origin_x = anchor_bounds.x; // left anchor
	
	switch ( c.anchor_x )
	{
		case 'right': origin_x = anchor_bounds.x + anchor_bounds.width; break;
		case 'center': origin_x = anchor_bounds.x + Math.round( anchor_bounds.width / 2 ); break;
	}
	
	x = origin_x; // right direction
	
	switch ( c.direction_x )
	{
		case 'left': x = origin_x - element_bounds.width; break;
		case 'center': x = origin_x - Math.round( element_bounds.width / 2 ); break;
	}
	
	
	//--------------------------------
	// Y coordinate
	//--------------------------------
	
	let y = 0;
	
	let origin_y = anchor_bounds.y + anchor_bounds.height; // bottom anchor
	
	switch ( c.anchor_y )
	{
		case 'top': origin_y = anchor_bounds.y; break;
		case 'center': origin_y = anchor_bounds.y + Math.round( anchor_bounds.height / 2 ); break;
	}
	
	y = origin_y; // bottom direction
	
	switch ( c.direction_y )
	{
		case 'top': y = origin_y - element_bounds.height; break;
		case 'center': y = origin_y - Math.round( element_bounds.height / 2 ); break;
	}
	
	
	//--------------------------------
	// Check collisions
	//--------------------------------
	
	if ( !allow_collision )
	{
		let min_x = document.documentElement.scrollLeft;
		let max_x = document.documentElement.clientWidth + document.documentElement.scrollLeft;
		
		let min_y = document.documentElement.scrollTop;
		let max_y = document.documentElement.clientHeight + document.documentElement.scrollTop;
		
		let max_collision_in_y = ( y + element_bounds.height ) > max_y;
		let min_collision_in_y = ( y < min_y );
		
		let max_collision_in_x = ( x + element_bounds.width ) > max_x;
		let min_collision_in_x = ( x < min_x );
		
		let new_combination;
		
		// Special case for collision in both axis
		if ( ( max_collision_in_y || min_collision_in_y ) && ( max_collision_in_x || min_collision_in_y ) )
			new_combination = Get_anchor_combination_for_collision( 'xy', c.index );
		else
		{
			// Priority for collisions from the bottom and right
			if ( max_collision_in_y || min_collision_in_y )
			{
				if ( c.direction_y == 'center' )
					y = max_collision_in_y
						? max_y - element_bounds.height // snap to max
						: min_y; // snap to min
				else
					new_combination = Get_anchor_combination_for_collision( 'y', c.index );
			}
			
			if ( max_collision_in_x || min_collision_in_x )
			{
				if ( c.direction_x == 'center' )
					x = max_collision_in_x
						? max_x - element_bounds.width // snap to max
						: min_x; // snap to min
				else
					new_combination = Get_anchor_combination_for_collision( 'x', c.index );
			}
		}
		
		if ( new_combination )
			return Get_anchored_position
			(
				element,
				{
					x: new_combination.anchor_x,
					y: new_combination.anchor_y,
					delta_x: a.delta_x,
					delta_y: a.delta_y,
					element: a.element,
					flip_priority: a.flip_priority
				},
				{
					x: new_combination.direction_x,
					y: new_combination.direction_y
				},
				true
			);
	}
	
	
	//--------------------------------
	// Apply deltas
	//--------------------------------
	
	// Deltas always apply towards the center of the anchor element, and don't apply to center directions. Center and left/top anchors are the same.
	if ( d.x != 'center' )
		x = `calc(${x}px ${a.x == 'right' ? '-' : '+'} ${a.delta_x})`;
	else
		x = `${x}px`;
	
	if ( d.y != 'center' )
		y = `calc(${y}px ${a.y == 'bottom' ? '-' : '+'} ${a.delta_y})`;
	else
		y = `${y}px`;
	
	return { left: x, top: y };
}
